import UrlDetailsPopover from '../../../partial/UrlDetailsPopover';

export const generateOpenSocialPopover = (
  popoverShow: any,
  setSocialLinkText: any,
  setSocialLinks: any,
  socialLinkText: any,
  socialLinks: any,
  returnFocusRef: any,
  onClose: () => void,
) => {
  return () => {
    popoverShow(UrlDetailsPopover, {
      setSocialLinkText: setSocialLinkText,
      setSocialLinks: setSocialLinks,
      socialLinkText: socialLinkText,
      socialLinks: socialLinks,
      returnFocusRef,
      popoverClose: onClose,
    });
  };
};
